import { render, staticRenderFns } from "./QColorCard.vue?vue&type=template&id=7d0499cd&scoped=true"
import script from "./QColorCard.vue?vue&type=script&lang=js"
export * from "./QColorCard.vue?vue&type=script&lang=js"
import style0 from "./QColorCard.vue?vue&type=style&index=0&id=7d0499cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0499cd",
  null
  
)

export default component.exports